export class ImageResource {
    constructor(
        public id?: number,
        public file?: any,
        public fileName?: string,
        public fileSize?: number,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource.model.ts